
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-art-generator",
      function () {
        return require("private-next-pages/ai-art-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-art-generator"])
      });
    }
  